__webpack_require__.p = "https://ikea.marat.qd.je/rs/sr/customer-service/support/";